import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

// PrimeNg
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { LupasComponent } from '../../general/lupas/lupas.component';
import { BotoneraApiService } from '../botonera.api.service';
import { IPaso, ISaltarPaso } from '../botonera.interface';
import { IFormSearchLupa, Item } from '../../general/lupas/interfaces/lupas.interfaces';
import { lastValueFrom } from 'rxjs';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
  selector: 'app-modal-saltar-paso',
  standalone: true,
  imports: [ReactiveFormsModule, CheckboxModule, ButtonModule, LupasComponent],
  templateUrl: './modal-saltar-paso.component.html',
  styleUrls: ['./modal-saltar-paso.component.scss'],
})
export class ModalSaltarPasoComponent {
    ref = inject(DynamicDialogRef);
    config = inject(DynamicDialogConfig);
    apiService = inject(BotoneraApiService);
  
    form: FormGroup = new FormGroup({});
    request: ISaltarPaso;
  
    // lupa
    dataSearchLupaPasoDestino: IFormSearchLupa = {
      idFormulario: 'noFormMotivosSaltarPaso',
      campo: 'noFormMotivosSaltarPaso',
      label: 'Saltar paso',
      dependencias: { IdfdCuerpo_Ini: null, CodfdDocPermitidos_Ini: null },
      required: true,
    };
  
    constructor() {
      this.request = this.config.data;
      this.buildForm();
      this.setDependenciasLupa();
    }
  
    async confirmar() {
      // recoge el motivo
      this.request.Motivo = this.form.get('Motivo')?.value;
      this.request.ArrastrarDoctos =  this.form.get('ArrastrarDoctos')?.value ?? false;
  
      // envia la solicitud al API
      const response = await lastValueFrom(this.apiService.PutSaltarPaso(this.request));
  
      // cierra el modal retornando la respuesta
      this.ref.close(response);
    }
  
    cerrarModal() {
      this.ref.close(false);
    }
  
    // Lupa
    buildForm() {
      this.form = new FormGroup({
        Codigo: new FormControl(null, Validators.required),
        Motivo: new FormControl(null, Validators.required),
        ArrastrarDoctos: new FormControl(
      this.request?.saltarPasoArrastrarDoctos ?? false
    )
      });
    }

    onPasoSeleccionado(item: Item) {
      const propertiesPasoDestino = (item.Propiedades ?? {}) as IPaso;
      this.request.CodfdCuerpoDestino = Number(propertiesPasoDestino.CodfdCuerpo); 
      this.request.CodfdDocPermitidos = Number(propertiesPasoDestino.CodfdDocPermitidos);
      this.request.CodGlobal = this.request.CodGlobal2;
      this.request.IdSaltarPasos = Number(item.Codigo);
    }

    setDependenciasLupa() {
      this.dataSearchLupaPasoDestino.dependencias = {
        IdfdCuerpo_Ini: this.request.CodfdCuerpo,
        CodfdDocPermitidos_Ini: this.request.CodfdDocPermitidos
      };
    }

  get mostrarCheck(): boolean {
  return this.request?.saltarPasoArrastrarDoctos === true;
  }
}
